export const limitsTranslationKeys = {
  PlayerWin: 'PLAYER',
  BankerWin: 'BANKER',
  Tie: 'TIE',
  PlayerPair: 'PLAYER_PAIR',
  BankerPair: 'BANKER_PAIR',
};
